module.exports = __webpack_public_path__ + "static/entrevista-frondizi-guevara-mn.944382d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/entrevista-frondizi-guevara-mn.jpg
// module id = 534
// module chunks = 114276838955818